// extracted by mini-css-extract-plugin
export default {"menu-item":"mobileNavItem_menu-item__Dy3Kj","icon":"mobileNavItem_icon__mU20S"};